{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Uusi viesti",
  "chat.scrollToBottom": "Selaa alas",
  "messagefeedback.thumbDown": "Huono vastaus",
  "messagefeedback.thumbUp": "Hyvä vastaus",
  "promptfield.aiDisclaimer": "Vastaukset tuotetaan tekoälyn avulla, ja ne voivat olla epätarkkoja. Tarkista ennen käyttöä.",
  "promptfield.aiUserGuidlines": "Tekoälyn käyttäjäohjeet",
  "promptfield.attachments": "Liitteet",
  "promptfield.insertButton": "Add",
  "promptfield.label": "Kehotus",
  "promptfield.placeholder": "Oletko valmis aloittamaan? Esitä kysymys, jaa idea tai lisää tehtävä.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Seis",
  "promptfield.submitButton": "Lähetä",
  "promptfield.uploading": "Lataaminen",
  "responsestatus.loading": "Ladataan",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Aloita äänitys",
  "voicebutton.stopListening": "Lopeta tallennus",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
